import dom from "../../../../common/ts/core/dom";

import {
    FILTER_NAMES,
    FILTERS_BAR_FORM_SELECTOR,
    FILTERS_MODAL_FORM_SELECTOR,
    FILTERS_SERP_SUGGESTION_FORM_SELECTOR
} from "../../../../common/ts/serp/filters/constants";

export default function filterFormData(formSelectors: string[]) {
    return formSelectors.reduce(
        (acc, formSelector) =>
            ({...acc, ...dom.getFormDataMultiSelection(formSelector)}),
        {}
    )
}

export function getFormDataSubmittingInFilterBar() {
    return filterFormData([FILTERS_MODAL_FORM_SELECTOR, FILTERS_BAR_FORM_SELECTOR, FILTERS_SERP_SUGGESTION_FORM_SELECTOR]);
}


export function getFormDataSubmittingFromFiltersModal() {
    return filterFormData([FILTERS_BAR_FORM_SELECTOR, FILTERS_MODAL_FORM_SELECTOR]);
}

export function getTrackingFormData(
    formData: { [p: string]: any },
    currentSearchParams: URLSearchParams,
) {
    const parsedFormData: { [key: string]: string } = {};
    const filters = Object.values(FILTER_NAMES)

    filters.forEach((key) => {
        if (formData[key] && formData[key] !== currentSearchParams.get(key)) {
            parsedFormData[key] = formData[key];
        }
    });

    return parsedFormData
}
